import { GitCommitIcon } from '@langchain/untitled-ui-icons';

import { useRef } from 'react';

import RelativeTime from '@/components/Hub/RelativeTime';
import { CommitWithLookupsSchema, RepoCommitTag } from '@/types/schema';
import { cn } from '@/utils/tailwind';

import { PromptPageTabs } from '../constants';
import { useRepoNavigation } from '../hooks/useRepoNavigation';
import CommitTags from './CommitTags';

export const CommitItem = ({
  commit,
  tags,
  active,
  inHub,
  owner,
  repo,
  setShowDiff,
  isFirstCommit,
}: {
  commit: CommitWithLookupsSchema;
  tags: RepoCommitTag[];
  inHub: boolean;
  active?: boolean;
  owner?: string;
  repo: string;
  setShowDiff: (showDiff: boolean) => void;
  isFirstCommit: boolean;
}) => {
  const commitHash = commit.commit_hash.substring(0, 8);

  const myTags = tags.filter((tag) => tag.commit_id === commit.id);
  const containerRef = useRef<HTMLDivElement>(null);

  const { navigateToTab } = useRepoNavigation({
    owner,
    repo,
    inHub,
    latestCommitHash: commitHash,
  });

  return (
    <div className="" ref={containerRef}>
      <button
        type="button"
        className="flex w-full cursor-pointer flex-row gap-1"
        onClick={() => {
          if (isFirstCommit) {
            setShowDiff(false);
          }
          navigateToTab(PromptPageTabs.COMMITS, commitHash);
        }}
      >
        <div
          className={cn(
            'flex w-full flex-col gap-2 border-b border-secondary bg-background p-3 transition-all hover:bg-secondary',
            active && 'bg-brand-green-25 hover:bg-brand-green-50'
          )}
        >
          <div className="my-auto flex flex-row items-center justify-start gap-3">
            <GitCommitIcon className={'h-4 w-4'} />

            <div className="text-sm font-medium leading-tight text-ls-black">
              {commitHash}
            </div>

            <div className="flex-grow" />

            <div className="flex items-center gap-3 text-sm text-tertiary">
              <RelativeTime utcTime={commit.created_at} />
            </div>
          </div>

          {commit.full_name && (
            <div className="my-[2px] flex text-xs font-normal leading-none text-slate-900 dark:text-slate-100">
              <span>
                by <span className="font-semibold">{commit.full_name}</span>
              </span>
            </div>
          )}

          <CommitTags
            tags={myTags}
            commit={commit}
            containerRef={containerRef}
            owner={owner}
            repo={repo}
          />
        </div>
      </button>
    </div>
  );
};
